import { CalculatorConfig, CalculatorId, CalculatorControl, ControlValues } from '../../lib/calculators/calculator-config';
import { CalculatorDescription } from '../../lib/calculators/calculator-description';
import { barGraphConfig } from './bar-graph/bar-graph.config';
import { barGraphDescription } from './bar-graph/bar-graph.description';
import { stackedBarGraphConfig } from './stacked-bar-graph/stacked-bar-graph.config';
import { stackedBarGraphDescription } from './stacked-bar-graph/stacked-bar-graph.description';
import { horizontalBarGraphConfig } from './horizontal-bar-graph/horizontal-bar-graph.config';
import { horizontalBarGraphDescription } from './horizontal-bar-graph/horizontal-bar-graph.description';
import { pieChartConfig } from './pie-chart/pie-chart.config';
import { pieChartDescription } from './pie-chart/pie-chart.description';
import { donutChartConfig } from './donut-chart/donut-chart.config';
import { donutChartDescription } from './donut-chart/donut-chart.description';
import { nightingaleRoseConfig } from './nightingale-rose/nightingale-rose.config';
import { nightingaleRoseDescription } from './nightingale-rose/nightingale-rose.description';
import { columnGraphConfig } from './column-graph/column-graph.config';
import { columnGraphDescription } from './column-graph/column-graph.description';
import { scatterChartConfig } from './scatter-chart/scatter-chart.config';
import { scatterChartDescription } from './scatter-chart/scatter-chart.description';
import { xyPlotConfig } from './x-y-plot/x-y-plot.config';
import { xyPlotDescription } from './x-y-plot/x-y-plot.description';
import { histogramConfig } from './histogram/histogram.config';
import { histogramDescription } from './histogram/histogram.description';
import { radarChartConfig } from './radar-chart/radar-chart.config';
import { radarChartDescription } from './radar-chart/radar-chart.description';
import { boxPlotConfig } from './box-plot/box-plot.config';
import { boxPlotDescription } from './box-plot/box-plot.description';
import { heatmapConfig } from './heatmap/heatmap.config';
import { heatmapDescription } from './heatmap/heatmap.description';
import { lineGraphConfig } from './line-graph/line-graph.config';
import { lineGraphDescription } from './line-graph/line-graph.description';
import { areaGraphConfig } from './area-graph/area-graph.config';
import { areaGraphDescription } from './area-graph/area-graph.description';
import { sunburstConfig } from './sunburst-chart/sunburst-chart.config';
import { sunburstChartDescription } from './sunburst-chart/sunburst-chart.description';
import { treeConfig } from './tree-chart/tree-chart.config';
import { treeChartDescription } from './tree-chart/tree-chart.description';
import { sankeyConfig } from './sankey-chart/sankey-chart.config';
import { sankeyChartDescription } from './sankey-chart/sankey-chart.description';
import { timeseriesConfig } from './timeseries-chart/timeseries-chart.config';
import { timeseriesChartDescription } from './timeseries-chart/timeseries-chart.description';
import { anovaConfig } from './anova/anova.config';
import { anovaDescription } from './anova/anova.description';
import { binomialConfig } from './binomial-distribution/binomial.config';
import { binomialDescription } from './binomial-distribution/binomial.description';
import { poissonConfig } from './poisson-distribution/poisson.config';
import { poissonDescription } from './poisson-distribution/poisson.description';
import { normalConfig } from './normal-distribution/normal.config';
import { normalDescription } from './normal-distribution/normal.description';
import { chiSquareConfig } from './chi-square/chi-square.config';
import { chiSquareDescription } from './chi-square/chi-square.description';
import { coefficientConfig } from './coefficient-of-variation/coefficient-of-variation.config';
import { coefficientDescription } from './coefficient-of-variation/coefficient-of-variation.description';
import { confidenceIntervalConfig } from './confidence-interval/confidence-interval.config';
import { confidenceIntervalDescription } from './confidence-interval/confidence-interval.description';
import { correlationConfig } from './correlation-coefficient/correlation-coefficient.config';
import { correlationDescription } from './correlation-coefficient/correlation-coefficient.description';
import { covarianceConfig } from './covariance/covariance.config';
import { covarianceDescription } from './covariance/covariance.description';
import { fiveNumberSummaryConfig } from './five-number-summary/five-number-summary.config';
import { fiveNumberSummaryDescription } from './five-number-summary/five-number-summary.description';
import { iqrCalculatorConfig } from './iqr/iqr-calculator.config';
import { iqrDescription } from './iqr/iqr-calculator.description';
import { kurtosisCalculatorConfig } from './kurtosis/kurtosis-calculator.config';
import { kurtosisDescription } from './kurtosis/kurtosis-calculator.description';
import { meanCalculatorConfig } from './mean/mean-calculator.config';
import { meanDescription } from './mean/mean-calculator.description';
import { medianCalculatorConfig } from './median/median-calculator.config';
import { medianDescription } from './median/median-calculator.description';
import { modeCalculatorConfig } from './mode/mode-calculator.config';
import { modeCalculatorDescription } from './mode/mode-calculator.description';
import { percentileCalculatorConfig } from './percentile/percentile-calculator.config';
import { percentileCalculatorDescription } from './percentile/percentile-calculator.description';
import { quartileCalculatorConfig } from './quartile/quartile-calculator.config';
import { quartileDescription } from './quartile/quartile-calculator.description';
import { rangeCalculatorConfig } from './range/range-calculator.config';
import { rangeDescription } from './range/range-calculator.description';
import { standardDeviationCalculatorConfig } from './standard-deviation/standard-deviation-calculator.config';
import { standardDeviationDescription } from './standard-deviation/standard-deviation-calculator.description';
import { varianceCalculatorConfig } from './variance/variance-calculator.config';
import { varianceDescription } from './variance/variance-calculator.description';
import { statisticalSummaryCalculatorConfig } from './statistical-summary/statistical-summary-calculator.config';
import { statisticalSummaryCalculatorDescription } from './statistical-summary/statistical-summary-calculator.description';
import { zScoreCalculatorConfig } from './z-score/z-score-calculator.config';
import { zScoreDescription } from './z-score/z-score-calculator.description';
import { meanAbsoluteDeviationCalculatorConfig } from './mean-absolute-deviation/mean-absolute-deviation-calculator.config';
import { meanAbsoluteDeviationDescription } from './mean-absolute-deviation/mean-absolute-deviation-calculator.description';
import { medianAbsoluteDeviationCalculatorConfig } from './median-absolute-deviation/median-absolute-deviation-calculator.config';
import { medianAbsoluteDeviationDescription } from './median-absolute-deviation/median-absolute-deviation-calculator.description';
import { criticalValueConfig } from './critical-value/critical-value.config';
import { criticalValueDescription } from './critical-value/critical-value.description';
import { coefficientOfDeterminationConfig } from './coefficient-of-determination/coefficient-of-determination.config';
import { coefficientOfDeterminationDescription } from './coefficient-of-determination/coefficient-of-determination.description';
import { degreesOfFreedomConfig } from './degrees-of-freedom/degrees-of-freedom.config';
import { degreesOfFreedomDescription } from './degrees-of-freedom/degrees-of-freedom.description';
import { sumSquaredErrorsConfig } from './sum-squared-errors/sum-squared-errors.config';
import { sumSquaredErrorsDescription } from './sum-squared-errors/sum-squared-errors.description';

export type CalculatorMapEntry<T extends CalculatorId> = {
  config: CalculatorConfig<T>;
  description: CalculatorDescription;
};

type CalculatorsMap = {
  [T in CalculatorId]?: CalculatorMapEntry<T>;
};

export const calculatorsMap: CalculatorsMap = {
  [CalculatorId.BarGraph]: {
    config: barGraphConfig,
    description: barGraphDescription
  },
  [CalculatorId.StackedBarChart]: {
    config: stackedBarGraphConfig,
    description: stackedBarGraphDescription
  },
  [CalculatorId.HorizontalBarGraph]: {
    config: horizontalBarGraphConfig,
    description: horizontalBarGraphDescription
  },
  [CalculatorId.PieChart]: {
    config: pieChartConfig,
    description: pieChartDescription
  },
  [CalculatorId.DonutChart]: {
    config: donutChartConfig,
    description: donutChartDescription
  },
  [CalculatorId.NightingaleChart]: {
    config: nightingaleRoseConfig,
    description: nightingaleRoseDescription
  },
  [CalculatorId.ColumnChart]: {
    config: columnGraphConfig,
    description: columnGraphDescription
  },
  [CalculatorId.ScatterChart]: {
    config: scatterChartConfig,
    description: scatterChartDescription
  },
  [CalculatorId.XYPlot]: {
    config: xyPlotConfig,
    description: xyPlotDescription
  },
  [CalculatorId.Histogram]: {
    config: histogramConfig,
    description: histogramDescription
  },
  [CalculatorId.RadarChart]: {
    config: radarChartConfig,
    description: radarChartDescription
  },
  [CalculatorId.BoxPlot]: {
    config: boxPlotConfig,
    description: boxPlotDescription
  },
  [CalculatorId.Heatmap]: {
    config: heatmapConfig,
    description: heatmapDescription
  },
  [CalculatorId.LineChart]: {
    config: lineGraphConfig,
    description: lineGraphDescription
  },
  [CalculatorId.AreaChart]: {
    config: areaGraphConfig,
    description: areaGraphDescription
  },
  [CalculatorId.SunburstChart]: {
    config: sunburstConfig,
    description: sunburstChartDescription
  },
  [CalculatorId.TreeChart]: {
    config: treeConfig,
    description: treeChartDescription
  },
  [CalculatorId.SankeyChart]: {
    config: sankeyConfig,
    description: sankeyChartDescription
  },
  [CalculatorId.TimeseriesChart]: {
    config: timeseriesConfig,
    description: timeseriesChartDescription
  },
  [CalculatorId.ANOVA]: {
    config: anovaConfig,
    description: anovaDescription
  },
  [CalculatorId.BINOMIAL_DISTRIBUTION]: {
    config: binomialConfig,
    description: binomialDescription
  },
  [CalculatorId.POISSON_DISTRIBUTION]: {
    config: poissonConfig,
    description: poissonDescription
  } satisfies CalculatorMapEntry<CalculatorId.POISSON_DISTRIBUTION>,
  [CalculatorId.NORMAL_DISTRIBUTION]: {
    config: normalConfig,
    description: normalDescription
  },
  [CalculatorId.CHI_SQUARE]: {
    config: chiSquareConfig,
    description: chiSquareDescription
  },
  [CalculatorId.COEFFICIENT_OF_VARIATION]: {
    config: coefficientConfig,
    description: coefficientDescription
  },
  [CalculatorId.CONFIDENCE_INTERVAL]: {
    config: confidenceIntervalConfig,
    description: confidenceIntervalDescription
  },
  [CalculatorId.CORRELATION_COEFFICIENT]: {
    config: correlationConfig,
    description: correlationDescription
  },
  [CalculatorId.COVARIANCE]: {
    config: covarianceConfig,
    description: covarianceDescription
  },
  [CalculatorId.FIVE_NUMBER_SUMMARY]: {
    config: fiveNumberSummaryConfig,
    description: fiveNumberSummaryDescription
  },
  [CalculatorId.INTERQUARTILE_RANGE]: {
    config: iqrCalculatorConfig,
    description: iqrDescription
  },
  [CalculatorId.KURTOSIS]: {
    config: kurtosisCalculatorConfig,
    description: kurtosisDescription
  },
  [CalculatorId.MEAN]: {
    config: meanCalculatorConfig,
    description: meanDescription
  },
  [CalculatorId.MEDIAN]: {
    config: medianCalculatorConfig,
    description: medianDescription
  },
  [CalculatorId.MODE]: {
    config: modeCalculatorConfig,
    description: modeCalculatorDescription
  },
  [CalculatorId.PERCENTILE]: {
    config: percentileCalculatorConfig,
    description: percentileCalculatorDescription
  },
  [CalculatorId.QUARTILE]: {
    config: quartileCalculatorConfig,
    description: quartileDescription
  },
  [CalculatorId.RANGE]: {
    config: rangeCalculatorConfig,
    description: rangeDescription
  },
  [CalculatorId.STANDARD_DEVIATION]: {
    config: standardDeviationCalculatorConfig,
    description: standardDeviationDescription
  },
  [CalculatorId.VARIANCE]: {
    config: varianceCalculatorConfig,
    description: varianceDescription
  },
  [CalculatorId.SUMMARY]: {
    config: statisticalSummaryCalculatorConfig,
    description: statisticalSummaryCalculatorDescription
  },
  [CalculatorId.Z_SCORE]: {
    config: zScoreCalculatorConfig,
    description: zScoreDescription
  },
  [CalculatorId.MEAN_ABSOLUTE_DEVIATION]: {
    config: meanAbsoluteDeviationCalculatorConfig,
    description: meanAbsoluteDeviationDescription
  },
  [CalculatorId.MEDIAN_ABSOLUTE_DEVIATION]: {
    config: medianAbsoluteDeviationCalculatorConfig,
    description: medianAbsoluteDeviationDescription
  },
  [CalculatorId.CRITICAL_VALUE]: {
    config: criticalValueConfig,
    description: criticalValueDescription
  },
  [CalculatorId.COEFFICIENT_OF_DETERMINATION]: {
    config: coefficientOfDeterminationConfig,
    description: coefficientOfDeterminationDescription
  },
  [CalculatorId.DEGREES_OF_FREEDOM]: {
    config: degreesOfFreedomConfig,
    description: degreesOfFreedomDescription
  },
  [CalculatorId.SUM_SQUARED_ERRORS]: {
    config: sumSquaredErrorsConfig,
    description: sumSquaredErrorsDescription
  }
} as const; 